import { Images } from "../assets";

const Button = ({
  text,
  textSize = "text-base",
  width = "12rem",
  px = "px-4",
  py = "py-4",
  type = "button",
  orientation,
  onClick,
}) => {
  const imgSrc = Images.BUTTON_LINK;
  let rotate;

  switch (orientation) {
    case "south-east":
      rotate = 135;
      break;
    case "south-west":
      rotate = 225;
      break;
    case "north-east":
      rotate = 45;
      break;
    case "north-west":
      rotate = 315;
      break;
    case "south":
      rotate = 180; // Arrow points down
      break;
    case "north":
      rotate = 0; // Arrow points up
      break;
    case "east":
      rotate = 90; // Arrow points right
      break;
    case "west":
      rotate = 270; // Arrow points left
      break;
    default:
      rotate = 0;
      break;
  }

  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        className={`flex justify-between items-center bg-orange text-white hover:brightness-75 transition ${px} ${py} ${
          orientation === "south-east" ? "rounded-2xl" : "rounded-lg"
        }`}
        style={{ width }}
      >
        <p className={`${textSize}`}>{text}</p>
        <img
          src={imgSrc}
          alt="Lien"
          className="w-7 transition-transform duration-300"
          style={{ transform: `rotate(${rotate}deg)` }}
        />
      </button>
    </div>
  );
};

export default Button;
